import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Button, Card, Col, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fetchNotifications, clearState } from "../../features/profileSlice";  // Assuming you have these actions in your notification slice
import moment from "moment";  // To handle date formatting
import "../../static/css/App.css";

function Notifications() {
  const dispatch = useDispatch();
  const { notifications, error, success } = useSelector(
    (state) => state.profile // Adjust to access the profile slice
  );
  const [notificationTypes, setNotificationTypes] = useState([]);
  const [notifyList, setNotifyList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchNotificationsList(currentPage);
  }, [currentPage]); // Removed `dispatch` from dependencies to avoid unnecessary re-renders

  const fetchNotificationsList = (page) => {
    const offset = parseInt((page - 1) * itemsPerPage);
    dispatch(clearState());
    dispatch(fetchNotifications({ limit: itemsPerPage, offset }))
      .then((response) => {
        // Assuming the API returns pagination info like totalPages
        if (response.payload?.status === "SUCCESS") {
          setNotificationTypes(response.payload?.data?.notificationTypes || []);
          setNotifyList(response.payload?.data?.notifications || []);
          setTotalPages(Math.ceil(response.payload?.data?.totalRecords / itemsPerPage)); // Calculate total pages
        }
      });
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  if (!notifyList || notifyList.length === 0) {
    return <div className="text-center text-danger">No notifications available</div>; // Updated styling for empty state
  }

  return (
    <div>
      <Container fluid>
        {error && <div className="alert alert-danger">{error}</div>} {/* Error message */}
        {success && <div className="alert alert-success">Notification deleted successfully!</div>} {/* Success message */}
        <ul className="list-group">
          {notifyList.map((notification, index) => (
            <li
              key={notification.id}
              className="list-group-item d-flex justify-content-between align-items-start border-danger shadow-sm mb-2"
              style={{ borderLeft: "5px solid red", backgroundColor: "#fff5f5" }} // Red-themed styling
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold text-danger">{notification.title}</div> {/* Red title */}
                <p className="text-muted mb-1">{notification.message}</p> {/* Muted message */}
                <small className="text-danger">{moment(notification.createdAt).format("MMMM Do YYYY, h:mm:ss a")}</small> {/* Red timestamp */}
              </div>
              <span className="badge bg-danger rounded-pill">
                {notificationTypes[notification.notificationType]}
              </span> {/* Red badge */}
            </li>
          ))}
        </ul>

        <div className="d-flex justify-content-center mt-4">
          <nav>
            <ul className="pagination">
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  key={page + 1}
                  className={`page-item ${currentPage === page + 1 ? "active" : ""}`}
                  onClick={() => handlePageChange(page + 1)}
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className={`page-link ${currentPage === page + 1 ? "bg-danger text-white" : "bg-light text-danger"}`}
                  >
                    {page + 1}
                  </span>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </Container>
    </div>
  );
}

export default Notifications;
